import React from 'react';
import PropTypes from 'prop-types';
import { styleTab, styleActiveTab } from './constants';

class AuthTab extends React.Component {
   render() {
    const { onClick, type, event } = this.props;

    return (
      <span
        onClick={() => onClick(type, event)}
        style={event.isActive ? styleActiveTab : styleTab}
      >
        {event.children}
      </span>
    );
  }
}

AuthTab.propTypes = {
  onClick: PropTypes.func,
  event: PropTypes.object,
  type: PropTypes.string
};

export default AuthTab;
